/**
 * Service: cart
 * It maintains the state of the shopping cart
 * items - cart items of type event, inventory, membership, donation
 * id - cart id
 * couponCodes - coupons applied to the cart
 * membershipIds - membership ids of the transacting member (can be more than one - base + aux)
 * membershipCategoryId - membership level id of new membership being purchased.
 */
import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/cart/cart.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { CartService } from '@ng/core/cart/cart.service';

/**
 * Empty AngularJS module — preserved so `acme.common.service.cart`
 * keeps resolving. The actual factory is registered in ng-downgraded-components.ts.
 */
export const CartServiceModule = angular.module('acme.common.service.cart', []).name;